/*!jslint
  this
*/
jQuery(function ($) {
  "use strict";
  $(document).on("click", ".scroll-to", function(e) {
      var href = $(this).attr("href");
      var offsetTop = href === "#" ? 0 : $(href).offset().top;
      var HdTop = $(".site-header").outerHeight();
      $("html, body").stop().animate({
          scrollTop: offsetTop - HdTop
      }, 500);
      e.preventDefault();
    });
  $(document).on('click', '.nav-toggle', function(){
      $('html').toggleClass('nav-open');
  });
  $(document).on('click', '.nav-close', function(){
      $('html').toggleClass('nav-open');
  });
  
  
  
   function appHeight() {
      var wh = $(window).innerHeight();
      document.documentElement.style
        .setProperty('--app-height', wh + 'px');

    }
    window.addEventListener('resize', appHeight)
    appHeight();
    $(document).on('click', '.loadmore', function (e) {
        e.preventDefault();
        var $el = $(this),
            link = $el.attr('href');
         var $count = $(this).data('count');
        if ($el.attr('disabled'))
            return;
        $el.addClass('loading').attr('disabled', true);
        $el.find('span').html('Loading...')
        $("<div>").load(link + " #loadmorecontainer", function () {
            $("#loadmorecontainer").append($(this).find("#loadmorecontainer").html());
            $el.parents('.load-more').removeAttr('disabled').remove();
            if($count){
            $('.blog-list-filter-bottom span').html($count);
          }
          var waypoints = $('.loadmore').waypoint(function(direction) {
          if (direction === 'down') {
            $(this.element).trigger('click');
            this.destroy();
          }
      }, { offset: '100%' });
        });               
    });
    

    $('.video-popup, .vi-item-emb').magnificPopup({
      type: 'iframe',
      iframe: {
            markup: '<div class="mfp-iframe-scaler">'+
                    '<div class="mfp-close"></div>'+
                    '<iframe class="mfp-iframe" frameborder="0" allowfullscreen></iframe>'+
                    '</div>', 
            patterns: {
                youtube: {
                    index: 'youtube.com/', 
                    id: 'v=', 
                    src: '//www.youtube.com/embed/%id%?autoplay=1' 
                }
             },
             srcAction: 'iframe_src', 
         },
      callbacks: {
          open: function(el) {
            $('html').addClass('mfp-cs-open');
          },
      }
  });
  $(document).on('click', '.vi-item-inline', function(){
    $('#video-popup').find('video').find('source').attr('src', $(this).data('href'));
  });
  $('.vi-item-inline').magnificPopup({
        type: 'inline',
        midClick: true,
        callbacks: {
            open: function() {

                // https://github.com/dimsemenov/Magnific-Popup/issues/125

                // Play video on open:
                $(this.content).find('video')[0].load();
                $(this.content).find('video')[0].play();

            },
            close: function() {

                // Reset video on close:
                $(this.content).find('video')[0].load();

            }
        }
    });

});